module.exports = __webpack_public_path__ + "img/3FD93DEA-8999-428E-BD8A-EAC97CFB1F76.cf9543aa.png";